<template>
  <div id="student-list-page" class="page-view student-list">

    <new-message-button/>

    <div class="container">

      <div class="row student-list-actions my-3">
        <div class="col-12">
          <b-modal @change="clearModal()" id="modal-add-student" size="md" centered class="app-modals" title="SchülerIn hinzufügen" hide-footer ref="newStudentModal">
            <add-student ref="addModal" @add:student="addStudent()"/>
          </b-modal>
          <b-modal @change="clearModalEdit()" v-if="findStudent()" id="modal-edit-student" size="md" centered class="app-modals" title="SchülerIn bearbeiten" hide-footer ref="editStudentModal">
            <edit-student ref="editModal"  :student="findStudent()" @edit:student="$refs.editStudentModal.hide()"/>
          </b-modal>
          <b-btn v-b-modal.modal-add-student class="btn-student-list">SchülerIn hinzufügen</b-btn>
          <b-btn v-b-modal.modal-edit-student @click="isStudentSelected(Errors.EDIT)" :disabled="selectedIds.length > 1" class="btn-student-list">SchülerIn bearbeiten</b-btn>
          <b-btn v-b-modal.modal-deactivate-student class="btn-student-list" name="student-deactive">SchülerIn löschen </b-btn>
          <b-btn @click="exportPdf()" class="btn-student-list" name="student-pdf">PDF generieren</b-btn>
        </div>
      </div>

      <div class="row student-list-table">
        <div class="col-12">
          <b-table hover :items="studentList" :fields="fields" class="text-center">
            <template slot="HEAD_action" slot-scope="data">
              <input v-model="allSelected" id="all-students" type="checkbox">
              <label @click="selectAllStudents()" for="all-students"></label>
            </template>
            <template slot="action" slot-scope="row">
              <input :id="row.item.itemid" :checked="selectedIds.includes(row.item.itemid)" @click="selectStudent(row.item)" type="checkbox" :value="row.item.itemid">
              <label :for="row.item.itemid"></label>
            </template>
            <template slot="shulerin" slot-scope="row">
              <twemoji :content="row.item.firstname + ' ' + row.item.lastname" v-linkified/>
            </template>
            <template slot="first_parent" slot-scope="row">
              <div v-if="row.item.codes[0] && row.item.codes[0].parent" class="">
                {{ row.item.codes[0].parent.firstname }} {{ row.item.codes[0].parent.lastname }}
                <span @click="confirmDeactivation(row.item.codes[0].itemid)" class="parent-deactive">[deaktivieren]</span>
              </div>
              <div else></div>

            </template>
            <template slot="second_parent" slot-scope="row">
              <div v-if="row.item.codes[1] && row.item.codes[1].parent" class="">
                {{ row.item.codes[1].parent.firstname }} {{ row.item.codes[1].parent.lastname }}
                <span @click="confirmDeactivation(row.item.codes[1].itemid)" class="parent-deactive">[deaktivieren]</span>
              </div>
              <div else></div>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <b-modal ref="nothingSelectedModal" id="modal-no-student-selected" size="md" centered class="app-modals" title="Kein/e Schüler/in ausgewählt" hide-footer>
      <div class="px-4 pb-4 text-center">
        <p>{{modalErrorMessage}}</p>
        <b-button @click="$refs.nothingSelectedModal.hide()" class="btn-neue mt-3" variant="none">OK</b-button>
      </div>
    </b-modal>

    <b-modal ref="confirmDeactivationModal" id="modal-confirmation" size="md" centered class="app-modals" title="Deaktivieren" hide-footer>
      <div class="px-4 pb-4 text-center">
        <p>Sind Sie sicher, dass Sie diesen Erziehungsberechtigten deaktivieren möchten? Diese Aktion kann nicht rückgängig gemacht werden. Nach dem Deaktivieren können Sie via "PDF generieren" bei Bedarf einen neuen Code für den Schüler/die Schülerin herunterladen.</p>
        <b-button @click="deactivateParent(idForDeactivation)" class="btn-neue mt-3" variant="none">Ja</b-button>
        <b-button @click="$refs.confirmDeactivationModal.hide()" class="btn-neue mt-3" variant="none">Nein</b-button>
      </div>
    </b-modal>

    <b-modal ref="confirmStudentDeactivationModal" id="modal-deactivate-student" size="md" centered class="app-modals" title="SchülerIn löschen" hide-footer>
      <div class="px-4 pb-4 text-center">
        <p>Sind Sie sicher, dass Sie diese Schülerin / diesen Schüler löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.</p>
        <b-button @click="deactivateStudents()" class="btn-neue mt-3" variant="none">Schüler löschen</b-button>
        <b-button @click="$refs.confirmStudentDeactivationModal.hide()" class="btn-neue mt-3" variant="none">Abbrechen</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import childwebApi from '@/api/v1/childweb';
import codewebApi from '@/api/v1/codeweb';
import NewMessageButton from '@/components/Messages/New/NewMessageButton';
import AddStudent from '@/components/Student/New';
import EditStudent from '@/components/Student/Edit';

const Errors = Object.freeze({
  EDIT: 'Bitte wählen Sie den Schüler/die Schülerin aus, den/die Sie bearbeiten möchten.',
  DEACTIVATE: 'Bitte wählen Sie den Schüler/die Schülerin aus, den/die Sie deaktivieren möchten.',
  GENERATE_PDF: 'Bitte wählen Sie den Schüler/die Schülerin aus, für den/die Sie einen Code generieren möchten.',
});

function downloadPdf(data) {
  // let blob = new Blob([response.data], { type: 'application/pdf' } )
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(data, 'hallo_elterncode.pdf');
    return;
  }
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.href = window.URL.createObjectURL(data);
  link.download = 'hallo_elterncode.pdf';
  link.click();
}

export default {
  name: 'StudentList',
  components: { NewMessageButton, AddStudent, EditStudent },
  data() {
    return {
      fields: [
        'action',
        { key: 'shulerin', label: 'SchülerIn' },
        { key: 'first_parent', label: 'Erziehungsberechtigter 1' },
        { key: 'second_parent', label: 'Erziehungsberechtigter 2' }],
      studentList: [],
      selectedIds: [],
      allSelected: false,
      modalErrorMessage: '',
      idForDeactivation: '',
      Errors,
    };
  },
  methods: {

    clearModal() {
      this.$refs.addModal.clearData();
    },
    clearModalEdit() {
      this.$refs.editModal.clearData();
    },
    addStudent() {
      this.$refs.newStudentModal.hide();
      childwebApi.index((response) => { this.studentList = response.listresponse; });
    },
    findStudent() {
      return this.studentList.find(student => student.itemid === this.selectedIds[this.selectedIds.length-1]);
    },
    selectStudent(item) {
      const ids = this.selectedIds;
      // eslint-disable-next-line
      ids.includes(item.itemid) ? ids.splice(ids.indexOf(item.itemid), 1) : ids.push(item.itemid);
    },
    selectAllStudents() {
      if (!this.allSelected) this.selectedIds = this.studentList.map(item => item.itemid);
      else this.selectedIds = [];
      this.allSelected = !this.allSelected;
    },
    deactivateStudents() {
      if (!this.isStudentSelected(Errors.DEACTIVATE)) return;
      this.selectedIds.forEach((id, idsIndex) => {
        childwebApi.delete(id).then(() => {
          this.studentList.forEach((student, index) => {
            if (student.itemid === id) this.studentList.splice(index, 1);
          });
          if (idsIndex === (this.selectedIds.length - 1)) this.selectedIds = [];
        });
      });
      this.$refs.confirmStudentDeactivationModal.hide();
    },
    confirmDeactivation(id) {
      this.$refs.confirmDeactivationModal.show();
      this.idForDeactivation = id;
    },
    deactivateParent(id) {
      codewebApi.delete(id).then(() => {
        childwebApi.index((response) => { this.studentList = response.listresponse; });
        this.$refs.confirmDeactivationModal.hide();
      });
    },
    exportPdf() {
      if (!this.isStudentSelected(Errors.GENERATE_PDF)) return;
      childwebApi.exportPdf(this.selectedIds, (response) => {
        downloadPdf(response.data);
      });
    },
    isStudentSelected(errorMessage) {
      if (!this.selectedIds[0]) {
        this.modalErrorMessage = errorMessage;
        this.$refs.nothingSelectedModal.show();
        return false;
      }
      var current_student=this.findStudent();
      this.$refs.editModal.child.firstname=current_student.firstname;
      this.$refs.editModal.child.lastname=current_student.lastname;
      return true;
    },
  },
  created() {
    childwebApi.index((response) => { this.studentList = response.listresponse; });
  },
};
</script>



// WEBPACK FOOTER //
// src/views/StudentList/Index.vue